import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'
import _imports_1 from '@/app/ui/assets/svg/info-square.svg'


const _hoisted_1 = {
  style: {"width":"55rem","max-width":"80vw","max-height":"80vh"},
  class: "flex flex-col gap-y-4"
}
const _hoisted_2 = { class: "w-full px-4 flex flex-col" }
const _hoisted_3 = { class: "grid grid-cols-3 gap-4 px-2 py-2 border border-gray-lp-1400 rounded-md" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4.5 max-w-none",
  alt: "exclamation tiangle red"
}, null, -1)
const _hoisted_5 = { class: "px-4" }
const _hoisted_6 = { class: "flex items-center py-2 px-4 rounded-lg gap-x-3 bg-blue-lp-100 w-max" }
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4",
  alt: "info-square"
}, null, -1)
const _hoisted_8 = { class: "text-white whitespace-normal text-12px" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Total berat volume ")
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "font-semibold" }, " kargo pesawat ", -1)
const _hoisted_11 = { class: "border border-gray-lp-200 rounded-lg overflow-y-auto popup-dimension flex-grow relative ml-4 mr-4" }
const _hoisted_12 = { class: "w-full" }
const _hoisted_13 = /*#__PURE__*/_createVNode("thead", { class: "sticky top-0 z-10 bg-white border-b border-gray-lp-200 shadow-sm" }, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { class: "text-left font-semibold text-black-lp-300 p-3 whitespace-nowrap" }, " No. STT/bag "),
    /*#__PURE__*/_createVNode("th", { class: "text-left font-semibold text-black-lp-300 p-3 whitespace-nowrap" }, " Berat kotor "),
    /*#__PURE__*/_createVNode("th", { class: "text-left font-semibold text-black-lp-300 p-3 whitespace-nowrap" }, " Dimensi/paket (P x L x T) "),
    /*#__PURE__*/_createVNode("th", { class: "text-left font-semibold text-black-lp-300 p-3 pr-12 whitespace-nowrap" }, " Berat volume ")
  ])
], -1)
const _hoisted_14 = { class: "text-left px-4 py-1 text-12px whitespace-nowrap" }
const _hoisted_15 = { class: "text-left px-4 py-1 text-12px" }
const _hoisted_16 = { class: "text-left px-4 py-1 text-12px" }
const _hoisted_17 = { class: "text-left px-4 py-1 text-12px" }
const _hoisted_18 = {
  class: "flex justify-end w-full sticky bottom-0 z-10 bg-white pt-4 px-4",
  style: {"box-shadow":"0px -1px 4px 0px #1A142126"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_InputDimension = _resolveComponent("InputDimension")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    "model-value": _ctx.modelValue,
    "onUpdate:modelValue": _ctx.onClose,
    persistent: "",
    title: "Dimensi & berat",
    customBody: "py-3",
    class: "text-black-lp-300"
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_DataWrapper, {
              fontSize: 16,
              label: _ctx.$t('Total koli aktual'),
              class: "min-w-1/6 font-semibold",
              value: _ctx.recalculateSummary.totalPieces
            }, null, 8, ["label", "value"]),
            _createVNode(_component_DataWrapper, {
              fontSize: 16,
              label: _ctx.$t('Total berat kotor aktual'),
              class: "min-w-1/6 font-semibold",
              value: `${_ctx.formatFloat(_ctx.recalculateSummary.actualGrossWeight)} kg`
            }, null, 8, ["label", "value"]),
            _createVNode(_component_DataWrapper, {
              fontSize: 16,
              label: _ctx.$t('Total berat volume aktual'),
              class: "min-w-1/6 font-semibold",
              value: `${_ctx.formatFloat(_ctx.recalculateSummary.actualVolumeWeight)} kg`
            }, null, 8, ["label", "value"])
          ]),
          (_ctx.allErrorsSummary?.length)
            ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.allErrorsSummary, (error) => {
                return (_openBlock(), _createBlock("div", {
                  key: error,
                  class: "text-red-lp-100 text-12px xxl:text-14px flex items-center gap-x-2 mt-1.5"
                }, [
                  _hoisted_4,
                  _createTextVNode(" " + _toDisplayString(error), 1)
                ]))
              }), 128))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode("p", _hoisted_8, [
              _hoisted_9,
              _hoisted_10,
              _createTextVNode(" akan dibagi " + _toDisplayString(_ctx.formatMoney(_ctx.dimensionDivider)) + " dari dimensi. ", 1)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode("table", _hoisted_12, [
            _hoisted_13,
            _createVNode("tbody", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dimensionPerKoliList, (item, index) => {
                return (_openBlock(), _createBlock("tr", {
                  key: index,
                  class: "border-t border-gray-lp-200"
                }, [
                  _createVNode("td", _hoisted_14, _toDisplayString(item.sttOrBag), 1),
                  _createVNode("td", _hoisted_15, [
                    _createVNode(_component_lp_input, {
                      id: `input_gross_weight_piece_${index}`,
                      "model-value": _ctx.formatNumberToString(item.sttPieceGrossWeight),
                      suffix: "kg",
                      format: _ctx.formatNumberToString,
                      onChange: ($event: any) => (_ctx.onInputGrossWeight($event, index))
                    }, null, 8, ["id", "model-value", "format", "onChange"])
                  ]),
                  _createVNode("td", _hoisted_16, [
                    _createVNode(_component_InputDimension, {
                      id: `input_dimension_piece_${index}`,
                      "is-number": false,
                      class: "my-1.5",
                      length: _ctx.formatNumberNoDecimalToString(item.sttPieceLength),
                      width: _ctx.formatNumberNoDecimalToString(item.sttPieceWidth),
                      height: _ctx.formatNumberNoDecimalToString(item.sttPieceHeight),
                      format: _ctx.formatNumberNoDecimalToString,
                      onChange: ($event: any) => (_ctx.onInputDimension($event, index))
                    }, null, 8, ["id", "length", "width", "height", "format", "onChange"])
                  ]),
                  _createVNode("td", _hoisted_17, _toDisplayString(_ctx.formatNumberToString(item.sttPieceVolumeWeight)) + " kg ", 1)
                ]))
              }), 128))
            ])
          ])
        ]),
        _createVNode("div", _hoisted_18, [
          _createVNode(_component_LpButton, {
            color: "red-lp-100",
            textColor: "white",
            title: "Simpan",
            onClick: _ctx.onSave,
            disabled: _ctx.disabled
          }, null, 8, ["onClick", "disabled"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value", "onUpdate:modelValue"]))
}